import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/Login';
import { DashboardPage } from './pages/Dashboard';
import { VentesPage } from './pages/Ventes';
import { VenteNouveauPage } from './pages/VenteNouveau';
import { VenteDetailPage } from './pages/VenteDetail';
import { ImportHistoriquePage } from './pages/ImportHistorique';
import { ContactsPage } from './pages/Contacts';
import { ContactNouveauPage } from './pages/ContactNouveau';
import { ContactDetailPage } from './pages/ContactDetail';
import { ContactsPipelinePage } from './pages/ContactsPipeline';
import { RelancesPage } from './pages/Relances';
import { ContactsImportPage } from './pages/ContactsImport';
import { ReferencesPage } from './pages/References';
import { ReferenceNouveauPage } from './pages/ReferenceNouveau';
import { ReferenceDetailPage } from './pages/ReferenceDetail';
import { ReferenceRouleauxPage } from './pages/ReferenceRouleaux';
import { ContainersPage } from './pages/Containers';
import { ContainerNouveauPage } from './pages/ContainerNouveau';
import { ContainerDetailPage } from './pages/ContainerDetail';
import { TresoreriePage } from './pages/Tresorerie';
import { TresorerieGlobalWoodPage } from './pages/TresorerieGlobalWood';
import { TresorerieEncaissementsPage } from './pages/TresorerieEncaissements';
import { TresorerieAcomptesPage } from './pages/TresorerieAcomptes';
import { TresorerieAvoirsPage } from './pages/TresorerieAvoirs';
import { TresorerieChargesFixesPage } from './pages/TresorerieChargesFixes';
import { TresorerieCashflowPage } from './pages/TresorerieCashflow';
import { AvoirNouveauPage } from './pages/AvoirNouveau';
import { useBootstrapAuth } from './hooks/useBootstrapAuth';

export function App(): JSX.Element {
  useBootstrapAuth();

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<DashboardPage />} />
          <Route path="/ventes" element={<VentesPage />} />
          <Route path="/ventes/nouveau" element={<VenteNouveauPage />} />
          <Route path="/ventes/:id" element={<VenteDetailPage />} />
          <Route path="/import-historique" element={<ImportHistoriquePage />} />
          <Route path="/contacts" element={<ContactsPage />} />
          <Route path="/contacts/nouveau" element={<ContactNouveauPage />} />
          <Route path="/contacts/pipeline" element={<ContactsPipelinePage />} />
          <Route path="/contacts/relances" element={<RelancesPage />} />
          <Route path="/contacts/import" element={<ContactsImportPage />} />
          <Route path="/contacts/:id" element={<ContactDetailPage />} />
          <Route path="/references" element={<ReferencesPage />} />
          <Route path="/references/nouveau" element={<ReferenceNouveauPage />} />
          <Route path="/references/:id/rouleaux" element={<ReferenceRouleauxPage />} />
          <Route path="/references/:id" element={<ReferenceDetailPage />} />
          <Route path="/containers" element={<ContainersPage />} />
          <Route path="/containers/nouveau" element={<ContainerNouveauPage />} />
          <Route path="/containers/:id" element={<ContainerDetailPage />} />
          <Route path="/tresorerie" element={<TresoreriePage />} />
          <Route path="/tresorerie/global-wood" element={<TresorerieGlobalWoodPage />} />
          <Route path="/tresorerie/encaissements" element={<TresorerieEncaissementsPage />} />
          <Route path="/tresorerie/acomptes" element={<TresorerieAcomptesPage />} />
          <Route path="/tresorerie/avoirs" element={<TresorerieAvoirsPage />} />
          <Route path="/tresorerie/charges-fixes" element={<TresorerieChargesFixesPage />} />
          <Route path="/tresorerie/cashflow" element={<TresorerieCashflowPage />} />
          <Route path="/ventes/:id/avoirs/nouveau" element={<AvoirNouveauPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
